import React from "react";
import {
  // useCollectionData,
  useCollectionDataOnce,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import {
  // subdomainsCollection,
  useData,
  // usersCollection,
  phoneCollection,
  webstoreCollection,
} from "../../../components/firebase/DataProvider";
// import { firefunctions } from "../../../components/firebase/FirebaseProvider";
// import Circle from "../../../components/appLoading/circle";
//material
// import AccountCircleIcon from "@material-ui/icons/AccountCircle";
// import TreeView from "@material-ui/lab/TreeView";
import Typography from "@material-ui/core/Typography";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import TreeItem from "@material-ui/lab/TreeItem";
import useStyles from "./style";
import { Skeleton } from "@material-ui/lab";
import { Avatar } from "@material-ui/core";
// import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";

function UplineSaya() {
  const classes = useStyles();
  const { profil, phone } = useData();

  const phoneAgen = phoneCollection.where(
    "user_id",
    "==",
    profil.ref_agen?.user_id ?? null
  );
  const phoneDist = phoneCollection.where(
    "user_id",
    "==",
    profil.ref_distributor?.user_id ?? null
  );
  const phoneMent = phoneCollection.where(
    "user_id",
    "==",
    profil.ref_mentorbisnis?.user_id ?? null
  );

  const [myLogo, loadMl] = useDocumentDataOnce(
    webstoreCollection.doc(phone?.user_id ?? "unknown")
  );

  const [logoAgen, loadLa] = useDocumentDataOnce(
    webstoreCollection.doc(profil?.ref_agen?.user_id ?? "unknown")
  );

  const [logoDist, loadLd] = useDocumentDataOnce(
    webstoreCollection.doc(profil?.ref_distributor?.user_id ?? "unknown")
  );

  const [logoMent, loadLm] = useDocumentDataOnce(
    webstoreCollection.doc(profil?.ref_mentorbisnis?.user_id ?? "unknown")
  );

  // console.log(myLogo, logoAgen, logoDist, logoMent);

  const [phoneA, loadA] = useCollectionDataOnce(phoneAgen, { idField: "id" });
  const [phoneD, loadD] = useCollectionDataOnce(phoneDist, { idField: "id" });
  const [phoneM, loadM] = useCollectionDataOnce(phoneMent, { idField: "id" });
  // const [data, setData] = useState([]);

  // useEffect(() => {
  //   const getActiveDownline = firefunctions.httpsCallable("getActiveDownline");

  //   getActiveDownline({ user_id: profil.id }).then((res) => {
  //     setData([
  //       {
  //         nama: profil.nama,
  //         tipe_akun: profil.tipe_akun,
  //         user_id: profil.id,
  //         children: res.data,
  //       },
  //     ]);
  //   });

  //   return () => {
  //     setData([]);
  //   };
  // }, []);

  const newData =
    profil?.tipe_akun === "reseller"
      ? {
          reseller: {
            nama: profil?.nama,
            tipe_akun: "reseller",
            phone: phone?.id,
            domain: myLogo?.domain,
            image: myLogo?.logo,
          },
          agen: {
            nama: profil?.ref_agen?.subdomain,
            tipe_akun: "agen",
            phone: phoneA?.[0]?.id,
            domain: profil?.ref_agen?.subdomain,
            image: logoAgen?.logo,
          },
          mentor: {
            nama: profil?.ref_mentorbisnis?.subdomain,
            tipe_akun: "mentorbisnis",
            phone: phoneM?.[0]?.id,
            domain: profil?.ref_mentorbisnis?.subdomain,
            image: logoMent?.logo,
          },
          distributor: {
            nama: profil?.ref_distributor?.subdomain,
            tipe_akun: "distributor",
            phone: phoneD?.[0]?.id,
            domain: profil?.ref_distributor?.subdomain,
            image: logoDist?.logo,
          },
        }
      : profil?.tipe_akun === "agen"
      ? {
          agen: {
            nama: profil?.nama,
            tipe_akun: "agen",
            phone: phone?.id,
            domain: myLogo?.domain,
            image: myLogo?.logo,
          },
          mentor: {
            nama: profil?.ref_mentorbisnis?.subdomain,
            tipe_akun: "mentorbisnis",
            phone: phoneM?.[0]?.id,
            domain: profil?.ref_mentorbisnis?.subdomain,
            image: logoMent?.logo,
          },
          distributor: {
            nama: profil?.ref_distributor?.subdomain,
            tipe_akun: "distributor",
            phone: phoneD?.[0]?.id,
            domain: profil?.ref_distributor?.subdomain,
            image: logoDist?.logo,
          },
        }
      : profil?.tipe_akun === "distributor"
      ? {
          distributor: {
            nama: profil?.nama,
            tipe_akun: "distributor",
            phone: phone?.id,
            domain: myLogo?.domain,
            image: myLogo?.logo,
          },
          mentor: {
            nama: profil?.ref_mentorbisnis?.subdomain,
            tipe_akun: "mentorbisnis",
            phone: phoneM?.[0]?.id,
            domain: profil?.ref_mentorbisnis?.subdomain,
            image: logoMent?.logo,
          },
        }
      : null;

  const dataKu = [newData];
  // console.log(dataKu[0]?.distributor);
  // console.log(profil, phone, myLogo);
  if (loadA || loadD || loadLa || loadLd || loadLm || loadM || loadMl) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const TeamView = ({ data, showPhone }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "3%",
        }}
      >
        <div
          style={{
            display: "flex",
            marginLeft: "1.5%",
            width: "70%",
          }}
        >
          <Avatar className={classes.medium}>
            {!data?.image ? (
              <SupervisedUserCircleIcon
                style={{ width: 40, height: 40, borderRadius: 50 }}
              />
            ) : (
              <img
                style={{
                  // width: 40,
                  height: 40,
                  // borderRadius: 50,
                }}
                src={data?.image}
                alt="logo"
              />
            )}
          </Avatar>
          <div style={{ marginLeft: "1.5%", width: "inherit" }}>
            <div style={{ display: "flex" }}>
              <div style={{ display: "inline-grid" }}>
                <Typography
                  noWrap
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {data?.nama}
                </Typography>
              </div>
              {/* <div
                style={{
                  backgroundColor: "#FED0E0",
                  borderRadius: 4,
                  marginLeft: 8,
                  justifyContent: "center",
                }}
              >
                <text
                  style={{
                    fontSize: 12,
                    fontWeight: "bold",
                    margin: "3px",
                    fontVariant: "small-caps",
                    color: "#f44336",
                  }}
                >
                  {data?.tipe_akun}
                </text>
              </div> */}
            </div>
            <div>
              <Typography noWrap style={{ fontSize: 13 }}>
                {data?.domain}.tokorame.store
              </Typography>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "40%",
            // marginRight: "1,5%",
            justifyContent: "flex-end",
          }}
        >
          <div style={{ marginRight: "20px" }}>
            <div style={{ display: "flex", float: "right" }}>
              <div style={{ display: "inline-grid" }}>
                <Typography
                  noWrap={true}
                  style={{
                    fontSize: 13,
                    // fontWeight: "bold",
                    // textTransform: "capitalize",
                  }}
                >
                  {showPhone ? data?.phone : "-"}
                </Typography>
              </div>
            </div>
            <div>
              <Typography
                // color="secondary"
                style={{
                  fontSize: 12,
                  fontWeight: "bold",
                  // margin: "3px",
                  fontVariant: "small-caps",
                  color: "#f44336",
                  float: "right",
                }}
              >
                {data?.tipe_akun}
              </Typography>
            </div>
          </div>

          {/* <div
            style={{
              // marginLeft: "1.5%",
              marginRight: "5%",
            }}
          >
            <Typography style={{ fontSize: 13 }}>{showPhone?data?.phone:"-"}</Typography>
          </div> */}
          {/* <div
          style={{
            marginLeft: "1.5%",
            marginRight: "1.5%",
          }}
        >
          <DoubleArrowIcon
            color="secondary"
            style={{
              // backgroundColor:"pink",
              transform: "rotate(-90deg)",
            }}
          />
        </div> */}
        </div>
      </div>
    );
  };

  return (
    <>
      {profil?.tipe_akun === "reseller" ? (
        <div>
          <TeamView data={dataKu[0]?.mentor} />
          <TeamView data={dataKu[0]?.distributor} />
          <TeamView data={dataKu[0]?.agen} showPhone={true} />
          <TeamView data={dataKu[0]?.reseller} showPhone={true} />
        </div>
      ) : profil?.tipe_akun === "agen" ? (
        <div>
          <TeamView data={dataKu[0]?.mentor} />
          <TeamView data={dataKu[0]?.distributor} showPhone={true} />
          <TeamView data={dataKu[0]?.agen} showPhone={true} />
        </div>
      ) : profil?.tipe_akun === "distributor" ? (
        <div>
          <TeamView data={dataKu[0]?.mentor} showPhone={true} />
          <TeamView data={dataKu[0]?.distributor} showPhone={true} />
        </div>
      ) : null}
      {/* {data.map((node) => {
        return (
          <>
            <TreeView
              key={node.user_id}
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
            >
              <TreeItem
                key={node.user_id}
                nodeId={node.user_id}
                label={
                  <Typography
                    className={classes.liquidBlue}
                  >{`Saya, ${node.nama} (${node.tipe_akun})`}</Typography>
                }
              >
                {profil.ref_mentorbisnis ? (
                  <TreeItem
                    nodeId="2"
                    label={
                      <Typography
                        className={classes.liquidSecondCa}
                      >{`> Mentorbisnis : ${
                        profil.ref_mentorbisnis?.subdomain
                      } ${
                        profil?.tipe_akun === "distributor"
                          ? ` - (${phoneM[0]?.id})`
                          : ""
                      }`}</Typography>
                    }
                  />
                ) : null}
                {profil.ref_distributor ? (
                  <TreeItem
                    nodeId="2"
                    label={
                      <Typography
                        className={classes.liquidSecondCa}
                      >{`> Distributor : ${profil.ref_distributor?.subdomain} ${
                        profil?.tipe_akun === "agen"
                          ? ` - (${phoneD[0]?.id})`
                          : ""
                      }`}</Typography>
                    }
                  />
                ) : null}
                {profil.ref_agen ? (
                  <TreeItem
                    nodeId="2"
                    label={
                      <Typography className={classes.liquidSecondCa}>
                        {`> Agen : ${profil.ref_agen?.subdomain}
                        ${
                          profil?.tipe_akun === "reseller"
                            ? ` - (${phoneA[0]?.id})`
                            : ""
                        }
                        `}
                      </Typography>
                    }
                  />
                ) : null}
              </TreeItem>
            </TreeView>
          </>
        );
      })} */}
    </>
  );
}

export default UplineSaya;
